import * as React from 'react';
import Slider from 'react-input-slider';
import axios from 'axios';

export const Calculator: React.FC = () => {
    const [firstName, setFirstName] = React.useState<string>('');
    const [lastName, setLastName] = React.useState<string>('');

    const [companyName, setCompanyName] = React.useState<string>('');
    const [contactNumber, setContactNumber] = React.useState<string>('');
    const [emailAddress, setEmailAddress] = React.useState<string>('');

    const [employees, setEmployees] = React.useState<number>(20);
    const [loading, setLoading] = React.useState<boolean>(false);

    const maxEmployees = 200;

    const testMode = false;
    
    let apiBase = "https://calculator-api.payrollmalta.com";
    if (testMode) {
        apiBase = "http://localhost:4000";
    }

    const [monthlyFee, setMonthlyFee] = React.useState<number>(0);
    const [setupFee, setSetupFee] = React.useState<number>(0);
    const [fixedMonthly, setFixedMonthly] = React.useState<number>(0);
    const [quoteStage, setQuoteStage] = React.useState<boolean>(false);
    const [emailedStage, setEmailedStage] = React.useState<boolean>(false);


    if (loading) {
        return <div className="pm-calc-container">
            <div className="loading-container">
                <img src="https://payrollmalta.com/wp-content/uploads/loading.gif" alt="PayrollMalta" />
                <p>Please wait a moment while we generate your quotation.</p>
            </div>
        </div>
    }

    if (emailedStage) {
        return <div className="pm-calc-container">
            <div className="done-container">
                <img className="logo" src="https://payrollmalta.com/wp-content/uploads/payrollmalta-logo.png" alt="PayrollMalta" />
                <p>All done!</p>
                <p>Your quote has been sent to {emailAddress}.</p>
            </div>
        </div>
    }

    if (quoteStage) {
        return <div className="pm-calc-container">
        <div className="quote-container">
           <div className="quote-params">
           <div className="form-row">
                <div className="form-group">
                    <span className="quoteInterval">Employees</span>
                    <span className="quoteAmount">{employees}</span>
                </div>
            </div>
           <table className="quote-highlight">
               <tr>
                <td className="quote-highlight-td">
                    <span className="quoteInterval">One-Time<br />Setup Fee</span>
                    <span className="quoteAmount">&euro;{setupFee}</span>
                </td>

                <td className="quote-highlight-td">
                    <span className="quoteInterval">Monthly Fee<br />Per Employee</span>
                    <span className="quoteAmount">&euro;{monthlyFee}</span>
                </td>
                
                <td className="quote-highlight-td">
                    <span className="quoteInterval">Additional Fixed<br />Monthly Fee</span>
                    <span className="quoteAmount">&euro;{fixedMonthly}</span>
                </td>
                </tr>
            </table>
            </div>

            <h3>The quote includes:</h3>
            <ul>
                <li>Setup up via import of data</li>
                <li>Unlimited Engagements & Terminations on payroll</li>
                <li>Payroll calculations</li>
                <li>Basic payroll reporting</li>
                <li>Payslips via email to employees</li>
                <li>Online Leave Portal</li>
                <li>Salary payments by Bank Transfer</li>
                <li>Submission of FSS documents to Commissioner for Revenue</li>
                <li>Unlimited support by our team of payroll professionals</li>
            </ul>

            <h3>Additional services we can offer at a seperate cost:</h3>
            <ul>
                <li>Jobsplus</li>
                <li>Reviewing of Time & Attendance</li>
                <li>Payment of monthly FS5s to Commissioner for Revenue</li>
                <li>Work Permit Applications</li>
            </ul>

            
            <div className="form-group">
                <button className="btn btn-send-quote" type="button" onClick={async (e) => {
                    e.preventDefault();

                    setLoading(true);
                    const response = await axios.post(
                        `${apiBase}/send-quote`,
                        {
                            employees,
                            firstName,
                            lastName,
                            companyName,
                            emailAddress,
                            contactNumber,
                        }
                    );

                    setLoading(false);
                    if(response.status !== 200 || !response.data.success) {
                        // TODO: Show some error
                        return;
                    }
                    setEmailedStage(true);
                    
                }}>Send a copy of this quote by email</button>
                <div style={{textAlign: 'center', marginTop: '5px'}}>{emailAddress}</div>
            </div>
        </div>
    </div>
    }

    return (
        <div className="pm-calc-container">
            <div className="pm-calc-pricing-container">
                <div className="pm-calc-content">
                    <form onSubmit={async (e) => {
                        e.preventDefault();
                        setLoading(true);
                        
                        const response = await axios.post(
                            `${apiBase}/get-quote`,
                            {
                                employees,
                                firstName,
                                lastName,
                                companyName,
                                emailAddress,
                                contactNumber
                            }
                        );
                        
                        setLoading(false);
                        if(response.status !== 200 || !response.data.success) {
                            // TODO: Show some error
                            return;
                        }

                        setMonthlyFee(response.data.monthlyFee);
                        setSetupFee(response.data.setupFee);
                        setFixedMonthly(response.data.fixedMonthly);
                        setQuoteStage(true);
                    }}>
                        <div className="form-group">
                            <label>
                                Company name:
                                <input
                                    id="companyName"
                                    name="companyName"
                                    value={companyName}
                                    onChange={(e) => setCompanyName(e.target.value)}
                                    type="text"
                                    placeholder="Company name"
                                    required
                                />
                            </label>
                        </div>


                        <div className="form-row">
                            <div className="form-group">
                                <label>
                                    <span style={{display: "block", marginBottom: "8px"}}>Number of employees:</span>
                                    <Slider
                                        axis="x"
                                        xmin={1}
                                        xmax={maxEmployees}
                                        x={employees}
                                        onChange={(sliderData: any) => setEmployees(sliderData.x)}
                                        styles={{
                                            active: {
                                                backgroundColor: '#7abc64'
                                            },
                                            thumb: {
                                                backgroundColor: '#284c68'
                                            }
                                        }}
                                    />
                                </label>
                            </div>

                            <div className="form-group">
                                <input
                                    id="number-of-employees"
                                    name="number-of-employees"
                                    placeholder="###"
                                    onChange={(e) => {
                                        let newEmployees = 0;
                                        if (e.target.value.trim() !== "") {
                                            newEmployees = parseInt(e.target.value);
                                        }
                                        if (newEmployees > maxEmployees) {
                                            newEmployees = maxEmployees;
                                        }
                                        setEmployees(newEmployees);
                                    }}
                                    type="number"
                                    value={employees > 0 ? employees : ''}
                                    min={1}
                                    max={maxEmployees}
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>
                                    First name:
                                    <input
                                        id="firstName"
                                        name="firstName"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        type="text"
                                        placeholder="First name"
                                        required
                                    />
                                </label>
                            </div>

                            <div className="form-group">
                                <label>
                                    Last name:
                                    <input
                                        id="lastName"
                                        name="lastName"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                        type="text"
                                        placeholder="Last name"
                                        required
                                    />
                                </label>
                            </div>
                        </div>

                        <div className="form-group">
                            <label>
                                Email address:
                                <input
                                    id="emailAddress"
                                    name="emailAddress"
                                    value={emailAddress}
                                    onChange={(e) => setEmailAddress(e.target.value)}
                                    type="email"
                                    placeholder="Email address"
                                    required
                                />
                            </label>
                        </div>

                        <div className="form-group">
                            <label>
                                Contact number:
                                <input
                                    id="contactNumber"
                                    name="contactNumber"
                                    value={contactNumber}
                                    onChange={(e) => setContactNumber(e.target.value)}
                                    type="text"
                                    placeholder="Contact number"
                                    required
                                />
                            </label>
                        </div>
{employees >= 200 && (
    <div className="more-than-200">For more than 200 employees email us on hello@payrollmalta.com to get your quote.</div>
)}


                        <div className="form-group">
                            <button className="btn btn-calculate" type="submit">Calculate</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
